import { Classes, Dialog } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { DefaultButton } from "@/components/pieces/button/DefaultButton";
import { PrimaryButton } from "@/components/pieces/button/PrimaryButton";
import {
  ClientCancelRefundableMeeting,
  CoachCancelRefundableMeeting,
} from "@/components/pieces/coaching/meetings/CancelMeetingConfirmDialog";

interface CancelBookingRequestConfirmDialogProps {
  isCoach: boolean;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  loading: boolean;
}

export function CancelBookingRequestConfirmDialog({
  isCoach,
  isOpen,
  onCancel,
  onConfirm,
  loading,
}: CancelBookingRequestConfirmDialogProps) {
  return (
    <>
      <Dialog
        isOpen={isOpen}
        icon="trash"
        title={<Box py={2}>Cancel this request booking ?</Box>}
        canEscapeKeyClose={false}
        canOutsideClickClose={false}
        style={{ maxWidth: 550, width: "95%" }}
        onClose={onCancel}
      >
        <Box p={24}>
          <Box className={`${Classes.DIALOG_BODY} ${Classes.RUNNING_TEXT}`}>
            {isCoach ? (
              <CoachCancelRefundableMeeting />
            ) : (
              <ClientCancelRefundableMeeting />
            )}
          </Box>
          <Flex className={Classes.DIALOG_FOOTER}>
            <Box>
              <DefaultButton disabled={loading} onClick={onCancel}>
                Nevermind
              </DefaultButton>
            </Box>
            <Box ml={3}>
              <PrimaryButton
                intent="primary"
                disabled={loading}
                loading={loading}
                onClick={() => onConfirm()}
              >
                Cancel Request
              </PrimaryButton>
            </Box>
          </Flex>
        </Box>
      </Dialog>
    </>
  );
}
